import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web and AsyncStorage for react-native
 
import thunk from 'redux-thunk';
import globalStateReducer from '../reducers/globalState';
import authReducer from '../reducers/auth';
import errorReducer from '../reducers/error';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
  //blacklist: ['auth']
}
 const combineReduxReducers = combineReducers({
  globalState: globalStateReducer,
  auth: authReducer,
  error: errorReducer
})
const persistedReducer = persistReducer(persistConfig, combineReduxReducers)

export default () => {
  let store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(thunk))
  );

  let persistor = persistStore(store)
  return { store, persistor }
};




// WEBPACK FOOTER //
// ./src/store/configureStore.js